webpackJsonp([137617487455182],{

/***/ 527:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.PriyaRajan = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(28);
	
	__webpack_require__(31);
	
	var _contentPage = __webpack_require__(4);
	
	var _contentPage2 = _interopRequireDefault(_contentPage);
	
	var _meta = __webpack_require__(5);
	
	var _meta2 = _interopRequireDefault(_meta);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(6);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Modal = __webpack_require__(8);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _insights_constants = __webpack_require__(25);
	
	var _reactBootstrap = __webpack_require__(22);
	
	var _reactSpinners = __webpack_require__(21);
	
	var _jquery = __webpack_require__(26);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactResponsive = __webpack_require__(23);
	
	var _reactResponsive2 = _interopRequireDefault(_reactResponsive);
	
	__webpack_require__(10);
	
	var _reactAnimateOnScroll = __webpack_require__(11);
	
	var _reactAnimateOnScroll2 = _interopRequireDefault(_reactAnimateOnScroll);
	
	var _reactPlayer = __webpack_require__(32);
	
	var _reactPlayer2 = _interopRequireDefault(_reactPlayer);
	
	var _sendMailIcon = __webpack_require__(30);
	
	var _sendMailIcon2 = _interopRequireDefault(_sendMailIcon);
	
	var _MailForwardForm = __webpack_require__(27);
	
	var _MailForwardForm2 = _interopRequireDefault(_MailForwardForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var icon1 = "https://winpeforum.com/assets/elements/Priya-Rajan.jpg";
	
	var TeamModal = function TeamModal(_ref) {
	  var activeItem = _ref.activeItem,
	      show = _ref.show,
	      onHide = _ref.onHide;
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    {
	      direction: "",
	      className: "teamdetails__wrapper",
	      show: show,
	      onHide: onHide,
	      style: { margin: "0% auto 0px" }
	    },
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "head_section" },
	        _react2.default.createElement(
	          "span",
	          { className: "item_name" },
	          activeItem.name
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "item_des" },
	          activeItem.post
	        )
	      ),
	      _react2.default.createElement(
	        "span",
	        { className: "cross pull-right" },
	        _react2.default.createElement("i", { onClick: onHide, className: "fa fa-times" })
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "item__desc" },
	        _react2.default.createElement("div", { dangerouslySetInnerHTML: { __html: activeItem.desc } })
	      )
	    ),
	    _react2.default.createElement(_Modal2.default.Footer, null)
	  );
	};
	TeamModal.propTypes = {
	  activeItem: _propTypes2.default.object,
	  show: _propTypes2.default.object,
	  onHide: _propTypes2.default.object
	};
	
	var PriyaRajan = exports.PriyaRajan = function (_React$Component) {
	  _inherits(PriyaRajan, _React$Component);
	
	  function PriyaRajan(args) {
	    _classCallCheck(this, PriyaRajan);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, args));
	
	    _this.toggleMailShareForm = function () {
	      _this.setState({ showMailShareForm: !_this.state.showMailShareForm });
	    };
	
	    _this.togglePopUp = function (item) {
	      _this.setState({
	        isShow: !_this.state.isShow,
	        activeItem: item || {}
	      });
	    };
	
	    _this.handleMenu = function (item) {
	      _this.setState({
	        activeTitle: item.title
	      });
	
	      var leftlist = [].concat(_insights_constants.insightsConstants);
	      _this.betterContent = [];
	      if (item.title === "SORT BY") {
	        [].concat(leftlist)
	        // .filter((a) => a.r_type === "Appetizer")
	        .forEach(function (item, i) {
	          return _this.betterContent.push(item);
	        });
	      } else if (item.title === "ALL") {
	        [].concat(leftlist)
	        // .filter((a) => a.r_type === "Appetizer")
	        .forEach(function (item, i) {
	          return _this.betterContent.push(item);
	        });
	      } else {
	        [].concat(leftlist).filter(function (insight) {
	          console.log(insight);
	          // a.typee.indexOf(item.title) >= 0}
	          var flag = false;
	          for (var i = 0; i < insight.itype.length; i++) {
	            if (item.title === insight.itype[i]) {
	              flag = true;
	            }
	          }
	          return flag;
	        }).forEach(function (item, i) {
	          return _this.betterContent.push(item);
	        });
	      }
	      _this.setState({
	        activeSortBy: item.title
	      });
	      setTimeout(function () {
	        _this.setState({
	          isSearching: false
	        });
	      }, 1000);
	    };
	
	    _this.handleSearch = function (e) {
	      var str = e.target.value.length ? e.target.value.toLowerCase().trim() : "";
	      _this.setState({
	        isSearching: true,
	        activeKeyword: str
	      });
	      var leftlist = [].concat(_insights_constants.insightsConstants);
	      _this.betterContent = [];
	      leftlist.forEach(function (item) {
	        if (item.skey.toLowerCase().trim().search(str) > -1) {
	          _this.betterContent.push(item);
	        }
	      });
	      setTimeout(function () {
	        _this.setState({
	          isSearching: false
	        });
	      }, 1000);
	    };
	
	    _this.state = {
	      activeItem: {},
	      isShow: false,
	      activeKeyword: "",
	      isSearching: false,
	      lastCounter: 3,
	      activeTitle: "SORT BY",
	      activeSortBy: "default",
	      showMailShareForm: false
	    };
	    _this.betterContent = _insights_constants.insightsConstants;
	    _this.TabContent = [
	    // {
	    // 	title: "POPULARITY",
	    // },
	    {
	      title: "ALL"
	    }, {
	      title: "BLOGS"
	    }, {
	      title: "INFOGRAPHICS"
	    }, {
	      title: "INTERVIEWS"
	    }, {
	      title: "VIDEOS"
	    }];
	    _this.Speaker = [{
	      desc: "<div>Priya is Market Lead\xA0for India and MENA in SVB\u2019s international market development\n        team, Global Gateway. She provides market entry advice and insights on cross-border\n        engagement focused on constituents in the innovation ecosystem \u2013 founders and\n        investors.\xA0\xA0<br/><br/>\n        \xA0\n        Priya\u2019s work with Indian entrepreneurs and venture capital funds has yielded tangible\n        value with founders accessing leading programs in the U.S. like Y-Combinator and\n        investors getting visibility of great founders and deals.\xA0\xA0<br/><br/>\n        \xA0\n        Priya calls on her experience, expertise and connections to champion a more inclusive\n        innovation economy. She works closely with community leaders, including Change\n        Catalyst,\xA0Kapor\xA0Capital, and YC Female Founders. She sits on the board of directors at\n        non-profits Big Brothers Big Sisters and Women Who Code \u2013 an organization dedicated\n        to helping women excel in technology careers. As a venture partner at\xA0Xfund, Priya\n        connects VC firms with superior research universities and advisor at Entrepreneurship\n        at Cornell University.\xA0<br/><br/>\n        \xA0\n        Priya co-created the Diaspora Community initiative at SVB and is a charter member\n        of\xA0TiE, a nonprofit focused on nurturing the next generation of entrepreneurs with Indian\n        ties.\xA0\xA0<br/><br/>\n        \xA0\n        Prior to joining Global Gateway, Priya was a Director in our early stage practice (Startup\n        Banking) where she led university programs and SVB Trek for student entrepreneurs.\n        Leading to partnerships with Dorm Room Fund, The House Fund, Stanford Venture\n        Studio and Rough Draft Ventures.\xA0<br/><br/>\n        \xA0\n        Priya\u2019s career at SVB Financial Group began as a global group financial officer, a\n        pivotal role in the Finance team. Earlier in her career, she held financial management\n        positions at Charles Schwab and Enterprise Rent-A-Car. In addition to a bachelor\u2019s\n        degree from the University of Madras and a master\u2019s degree in international business\n        from Queen\u2019s University, Priya holds an MBA in business administration from Cornell\n        University and a California CPA in accounting and business administration.\xA0<br/><br/>\n        \xA0\n         \n        \n        Priya enjoys travelling the world, opening doors, and meeting new people. When not on\n        a plane, Priya enjoys classical music \u2013 after studying music for over a decade, she\n        passed on this passion and skill to her two children.\n        .\n        \n        \n        \n        </div>",
	      name: "Priya Rajan",
	      post: "Market Lead for India and MENA, Silicon Valley Bank",
	      imgUrl: icon1,
	      head: "Vested in Innovation"
	    }];
	    return _this;
	  }
	
	  PriyaRajan.prototype.componentDidMount = function componentDidMount() {
	    // function sticky_relocate () {
	    // 	var window_top = $(window).scrollTop()
	    // 	var div_top = $("#sticky-anchor").offset().top
	    // 	if (window_top > div_top) {
	    // 		$("#sticky").addClass("stick")
	    // 	} else {
	    // 		$("#sticky").removeClass("stick")
	    // 	}
	    // }
	    // $(function () {
	    // 	$(window).scroll(sticky_relocate)
	    // 	sticky_relocate()
	    // })
	  };
	
	  PriyaRajan.prototype.render = function render() {
	    var _this2 = this;
	
	    var leftList = this.betterContent.filter(function (item) {
	      return item.url !== "/PriyaRajan";
	    });
	
	    var _state = this.state,
	        defaultStyle = _state.defaultStyle,
	        isSearching = _state.isSearching,
	        isShow = _state.isShow,
	        activeTitle = _state.activeTitle,
	        activeSortBy = _state.activeSortBy;
	    var location = this.props.location;
	
	    return _react2.default.createElement(
	      "div",
	      null,
	      _react2.default.createElement(_MailForwardForm2.default, {
	        show: this.state.showMailShareForm,
	        onClickClose: this.toggleMailShareForm,
	        url: "insights.php/forward",
	        insight: "Vested in Innovation"
	      }),
	      _react2.default.createElement(
	        _contentPage2.default,
	        null,
	        _react2.default.createElement(_meta2.default, {
	          title: "Winpe Insights | Vested in Innovation            ",
	          image: "https://winpeforum.com/assets/elements/priya-thumb.jpg",
	          description: "Priya Rajan has been at the heart of global innovation for more than a decade, leading global finance operations for Silicon Valley Bank. Having witnessed its evolution across markets and regions, she shares her insights into what drives entrepreneurial success and why the Indian VC market is exciting for investors.             ",
	          location: location,
	          keywords: ""
	        }),
	        _react2.default.createElement(_meta2.default, {
	          title: "Winpe Insights | Vested in Innovation ",
	          image: "https://winpeforum.com/assets/elements/priya-thumb.jpg",
	          description: "Priya Rajan has been at the heart of global innovation for more than a decade, leading global finance operations for Silicon Valley Bank. Having witnessed its evolution across markets and regions, she shares her insights into what drives entrepreneurial success and why the Indian VC market is exciting for investors.             ",
	          location: location,
	          keywords: ""
	        }),
	        _react2.default.createElement(
	          "div",
	          { className: "section__content" },
	          _react2.default.createElement(
	            "div",
	            { className: "insights_wrapper" },
	            _react2.default.createElement(
	              "div",
	              { className: "insights_section" },
	              _react2.default.createElement(
	                _reactResponsive2.default,
	                { query: "(min-width: 768px)" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "insights_main_heading" },
	                  _react2.default.createElement("div", { className: "left_line" }),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "insights_main_heading_text" },
	                    "Winpe INSIGHTS"
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _reactResponsive2.default,
	                {
	                  query: "(min-width: 767px)",
	                  style: { display: "none" }
	                },
	                _react2.default.createElement("div", { className: "insights_main_heading" })
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "insights_content" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "drop_src_box" },
	                  _react2.default.createElement(
	                    _reactResponsive2.default,
	                    { query: "(min-width: 768px)" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "left_drop_box" },
	                      _react2.default.createElement(
	                        _reactBootstrap.DropdownButton,
	                        { title: activeTitle },
	                        this.TabContent.map(function (item, j) {
	                          return _react2.default.createElement(
	                            _reactBootstrap.MenuItem,
	                            {
	                              onClick: function onClick() {
	                                return _this2.handleMenu(item);
	                              },
	                              activeSortBy: activeSortBy,
	                              text: item.title,
	                              key: j
	                            },
	                            item.title
	                          );
	                        })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactResponsive2.default,
	                    {
	                      query: "(max-width: 767px)",
	                      style: { display: "none" }
	                    },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "left_drop_box" },
	                      _react2.default.createElement(
	                        _reactBootstrap.DropdownButton,
	                        { title: activeTitle },
	                        this.TabContent.map(function (item, j) {
	                          return _react2.default.createElement(
	                            _reactBootstrap.MenuItem,
	                            {
	                              onClick: function onClick() {
	                                return _this2.handleMenu(item);
	                              },
	                              activeSortBy: activeSortBy,
	                              text: item.title,
	                              key: j
	                            },
	                            item.title
	                          );
	                        })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactResponsive2.default,
	                    { query: "(min-width: 768px)" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "left_scr_box" },
	                      _react2.default.createElement(
	                        "form",
	                        { id: "demo-2" },
	                        _react2.default.createElement("input", {
	                          type: "search",
	                          placeholder: "Search",
	                          onChange: function onChange(e) {
	                            return _this2.handleSearch(e);
	                          },
	                          value: this.state.activeKeyword
	                        })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactResponsive2.default,
	                    {
	                      query: "(max-width: 767px)",
	                      style: { display: "none" }
	                    },
	                    _react2.default.createElement("div", { className: "left_scr_box" })
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "insights_mid_section" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      _reactResponsive2.default,
	                      { query: "(min-width: 768px)" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-lg-3 col-md-3" },
	                        _react2.default.createElement("div", { id: "sticky-anchor" }),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "insights_left_listing" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "insights_left_listing_text" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "left_listing_card left_listing_card--feature" },
	                              _react2.default.createElement(
	                                "div",
	                                { className: "listing_t1" },
	                                _react2.default.createElement(
	                                  "span",
	                                  null,
	                                  "Interview\xA0"
	                                ),
	                                "\u2022 13 August 2021"
	                              ),
	                              _react2.default.createElement(
	                                "div",
	                                { className: "listing_t2" },
	                                "Vested in Innovation"
	                              ),
	                              _react2.default.createElement(
	                                "div",
	                                { className: "listing_t3" },
	                                "Priya Rajan of Silicon Valley Bank"
	                              )
	                            ),
	                            _react2.default.createElement("div", { className: "left_listing_card--feature__el1" }),
	                            isSearching ? _react2.default.createElement(
	                              "div",
	                              { style: { margin: "10% 25% 10%" } },
	                              _react2.default.createElement(_reactSpinners.ClipLoader, {
	                                color: "#22316B",
	                                loading: isSearching
	                              })
	                            ) : leftList.length ? leftList.slice(0, 27).map(function (item, i) {
	                              return _react2.default.createElement(
	                                "div",
	                                { className: "left_listing_card", key: i },
	                                _react2.default.createElement(
	                                  _gatsbyLink2.default,
	                                  {
	                                    to: "/insights/" + item.url.replace(/[^A-Z0-9]+/gi, "")
	                                  },
	                                  _react2.default.createElement(
	                                    "div",
	                                    { className: "listing_t1" },
	                                    _react2.default.createElement(
	                                      "span",
	                                      null,
	                                      item.type,
	                                      "\xA0"
	                                    ),
	                                    "\u2022 ",
	                                    item.date
	                                  ),
	                                  _react2.default.createElement(
	                                    "div",
	                                    { className: "listing_t2" },
	                                    item.ltitle
	                                  ),
	                                  _react2.default.createElement(
	                                    "div",
	                                    { className: "listing_t3" },
	                                    item.lname
	                                  )
	                                )
	                              );
	                            }) : _react2.default.createElement(
	                              "div",
	                              { className: "no__product" },
	                              "Not available in the list"
	                            )
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactResponsive2.default,
	                      {
	                        query: "(max-width: 767px)",
	                        style: { display: "none" }
	                      },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-lg-3 col-md-3" },
	                        _react2.default.createElement("div", { id: "sticky-anchor" }),
	                        _react2.default.createElement("div", { className: "insights_left_listing" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-lg-9 col-md-9" },
	                      _react2.default.createElement(
	                        _reactAnimateOnScroll2.default,
	                        {
	                          delay: 0,
	                          duration: 2,
	                          animateIn: "slideInRight",
	                          offset: 600
	                        },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "insights_right_text" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "insights_blog_page" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "back_event" },
	                              _react2.default.createElement(
	                                _gatsbyLink2.default,
	                                { to: "/insights" },
	                                _react2.default.createElement(
	                                  "i",
	                                  { className: "fa fa-arrow-left" },
	                                  " ",
	                                  "browse Insights"
	                                )
	                              )
	                            ),
	                            _react2.default.createElement(
	                              "div",
	                              { className: "insights_blog_text" },
	                              this.Speaker.map(function (item, i) {
	                                return _react2.default.createElement(
	                                  "div",
	                                  { className: "row" },
	                                  _react2.default.createElement(
	                                    _reactAnimateOnScroll2.default,
	                                    {
	                                      delay: 0,
	                                      duration: 1,
	                                      animateIn: "zoomIn",
	                                      offset: 100
	                                    },
	                                    _react2.default.createElement(
	                                      "div",
	                                      { className: "col-md-5 col-sm-6" },
	                                      _react2.default.createElement(
	                                        "div",
	                                        {
	                                          className: "right_img_section",
	                                          onClick: function onClick() {
	                                            return _this2.togglePopUp(item);
	                                          }
	                                        },
	                                        _react2.default.createElement("img", {
	                                          src: item.imgUrl,
	                                          alt: "priya rajan",
	                                          className: "img-responsive"
	                                        })
	                                      )
	                                    ),
	                                    _react2.default.createElement(
	                                      "div",
	                                      { className: "col-md-7 col-sm-6" },
	                                      _react2.default.createElement(
	                                        "div",
	                                        { className: "right_name_section" },
	                                        _react2.default.createElement(
	                                          "div",
	                                          { className: "r_head" },
	                                          item.head
	                                        ),
	                                        _react2.default.createElement(
	                                          "div",
	                                          { className: "r_name" },
	                                          item.name
	                                        ),
	                                        _react2.default.createElement(
	                                          "div",
	                                          { className: "r_post" },
	                                          "Market Lead\xA0for India and MENA, Silicon Valley Bank"
	                                        ),
	                                        _react2.default.createElement(
	                                          "div",
	                                          { className: "r_block" },
	                                          _react2.default.createElement(
	                                            "span",
	                                            null,
	                                            "INTERVIEW"
	                                          ),
	                                          " \u2022 6 mins read"
	                                        )
	                                      ),
	                                      _react2.default.createElement(
	                                        "div",
	                                        { className: "share_section_one" },
	                                        _react2.default.createElement(
	                                          "div",
	                                          { className: "headsocialLink" },
	                                          _react2.default.createElement(
	                                            "span",
	                                            { className: "hicon" },
	                                            _react2.default.createElement(
	                                              "a",
	                                              {
	                                                href: "https://www.facebook.com/sharer/sharer.php?u=https://winpeforum.com" + location.pathname,
	                                                target: "_blank",
	                                                className: "",
	                                                style: {
	                                                  display: "block !important"
	                                                }
	                                              },
	                                              _react2.default.createElement("img", {
	                                                src: "https://winpeforum.com/assets/elements/SM_icon_01_new.png",
	                                                alt: ""
	                                              })
	                                            )
	                                          ),
	                                          _react2.default.createElement(
	                                            "span",
	                                            { className: "hicon" },
	                                            _react2.default.createElement(
	                                              "a",
	                                              {
	                                                style: {
	                                                  display: "block !important"
	                                                },
	                                                href: "https://twitter.com/intent/tweet?url=https://winpeforum.com" + location.pathname,
	                                                target: "_blank",
	                                                className: ""
	                                              },
	                                              _react2.default.createElement("img", {
	                                                src: "https://winpeforum.com/assets/elements/SM_icon_02_new.png",
	                                                alt: ""
	                                              })
	                                            )
	                                          ),
	                                          _react2.default.createElement(
	                                            "span",
	                                            { className: "hicon" },
	                                            _react2.default.createElement(
	                                              "a",
	                                              {
	                                                style: {
	                                                  display: "block !important"
	                                                },
	                                                href: "https://www.linkedin.com/sharing/share-offsite/?url=https://winpeforum.com" + location.pathname,
	                                                target: "_blank",
	                                                className: ""
	                                              },
	                                              _react2.default.createElement("img", {
	                                                src: "https://winpeforum.com/assets/elements/social_Media_icon_03_new_new.png",
	                                                alt: ""
	                                              })
	                                            )
	                                          ),
	                                          _react2.default.createElement(
	                                            "span",
	                                            { className: "hicon" },
	                                            _react2.default.createElement(
	                                              "button",
	                                              {
	                                                style: {
	                                                  display: "block !important",
	                                                  width: "25px"
	                                                },
	                                                className: "forwardMail",
	                                                title: "Forward to email",
	                                                onClick: _this2.toggleMailShareForm
	                                              },
	                                              _react2.default.createElement("img", {
	                                                src: _sendMailIcon2.default,
	                                                alt: ""
	                                              })
	                                            )
	                                          )
	                                        )
	                                      )
	                                    )
	                                  )
	                                );
	                              })
	                            ),
	                            _react2.default.createElement(
	                              "div",
	                              { className: "insights_blog_text_btm" },
	                              _react2.default.createElement(
	                                "div",
	                                { className: "text_section" },
	                                _react2.default.createElement(
	                                  "div",
	                                  { className: "into_text" },
	                                  "Priya Rajan has been at the heart of global innovation for more than a decade, leading global finance operations for Silicon Valley Bank. Having witnessed its evolution across markets and regions, she shares her insights into what drives entrepreneurial success and why the Indian VC market is exciting for investors."
	                                ),
	                                _react2.default.createElement(
	                                  "div",
	                                  { className: "interview_vieo_section" },
	                                  _react2.default.createElement(
	                                    "div",
	                                    { className: "interview_video" },
	                                    _react2.default.createElement(
	                                      "div",
	                                      { className: "r_text_Q" },
	                                      _react2.default.createElement(
	                                        "b",
	                                        null,
	                                        " \u201CSuccess stories such as Freshworks, Druva, Postman, Browserstack, Darwinbox, Razorpay, Innovacer, Uniphore, and several others have amplified the Indian startup ecosystem\u2019s momentum. I expect global investor confidence will continue to increase and that investment dollars will continue to flow into the region. Founder, market, and investor maturity is visible and adds to the ease / fluidity / success of global businesses from India. We are going to see this exciting trend continue for years to come.\u201D"
	                                      ),
	                                      _react2.default.createElement("br", null),
	                                      _react2.default.createElement("br", null)
	                                    )
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  "div",
	                                  { className: "r_text_Q" },
	                                  "Q1. You have led the operations of SVB a long time and expanded its global footprint. What has been the most exciting part of your journey and what has been a constant and differential in your approach?"
	                                ),
	                                _react2.default.createElement(
	                                  "div",
	                                  { className: "r_text" },
	                                  "I am truly grateful to be a part of an organization that has been the core of global innovation for the last 14 years. In my first eight years of leading global finance operations, I had this unique opportunity to help expand SVB\u2019s global footprint. Over the last six years, I have worked directly with start-ups and funds in the US/Northern California and Global Markets (India and MENA). The hustle and passion of the global innovation ecosystem for creating and investing in what\u2019s next, is awe-inspiring. Being curious is vital and has been consistent across the roles I have taken on. As I am interacting with my global clients building cross-border SaaS solutions, organic baby products, blockchain or micro satellites, my approach is to be curious, listen, learn, and adapt with an aim to create value beyond banking.",
	                                  _react2.default.createElement("br", null)
	                                ),
	                                _react2.default.createElement(
	                                  "div",
	                                  { className: "r_text_Q" },
	                                  "Q2. In your experience of leading and scaling SVB, have you ever faced a circumstance wherein your decision making was questioned by your team or other stakeholders? What is your mantra in handling such situations?"
	                                ),
	                                _react2.default.createElement(
	                                  "div",
	                                  { className: "r_text" },
	                                  "My approach to decision-making has evolved over the years. The problem that is needed to be solved dictates the nuances to the process in most cases. It is critical at the end of the day that we prioritize our clients, employees, and shareholders first. We are a mission-driven organization guided by our values - empathy for others, speaking and acting with integrity, embracing diverse perspectives, taking responsibility, and most importantly, keeping learning and improving. When the priorities are clear, usually, the decisions tend to be more apparent.",
	                                  _react2.default.createElement("br", null)
	                                ),
	                                _react2.default.createElement(
	                                  "div",
	                                  { className: "r_text_Q" },
	                                  "Q3. You have been associated with organizations like Big Brothers Big Sisters and Women Who Code, organisations which groom women in technology. What is the one thing that women entrepreneurs struggle with the most and what advice do you give them for maximum impact?"
	                                ),
	                                _react2.default.createElement(
	                                  "div",
	                                  { className: "r_text" },
	                                  "Women, in general (me included), are perfectionists. We want to achieve/deliver 150% to represent us at 100%. Our hesitation in putting ourselves out there until we feel ready puts us behind the race from the start. \u201CBelieving in yourself\u201D is the first step. The confidence and approach of women entrepreneurs are changing for the better. Initiatives such as Neythri, CXXO by Kaalari, TiE Women, and several others are working tirelessly to help bridge the gap, empower women entrepreneurs and investors and inspire others to support this much- needed movement.",
	                                  _react2.default.createElement("br", null)
	                                ),
	                                _react2.default.createElement(
	                                  "div",
	                                  { className: "r_text_Q" },
	                                  "Q4. What has been SVB's approach with women entrepreneurs? How has SVB addressed some of the unconscious bias when it comes to fund raising by women entrepreneurs?"
	                                ),
	                                _react2.default.createElement(
	                                  "div",
	                                  { className: "r_text" },
	                                  "Black\xA0and Latinx\xA0individuals\xA0and women\xA0remain underrepresented in the innovation economy, especially in leadership roles\xA0as\xA0executives,\xA0board members,\xA0investors and startup founders.\xA0SVB\u2019s Access to Innovation program was launched to help build a more diverse, equitable and accessible innovation economy.\xA0 SVB has been at the center of innovation for nearly 40 years, and has the networks, the expertise and the perspective to help accomplish this goal. Together with our partners, we are building broader talent pipelines at all levels; providing access to resources and training; making funds available to entrepreneurs and investors; and opening up networks to those who have been excluded.\xA0",
	                                  _react2.default.createElement("br", null),
	                                  " For more information, visit\xA0",
	                                  _react2.default.createElement(
	                                    "a",
	                                    { href: "https://www.svb.com/about-us/living-our-values/access-to-innovation" },
	                                    "https://www.svb.com/about-us/living-our-values/access-to-innovation"
	                                  ),
	                                  _react2.default.createElement("br", null)
	                                ),
	                                _react2.default.createElement(
	                                  "div",
	                                  { className: "r_text_Q" },
	                                  "Q5.What has been some of the differences in the way gender diversity is viewed in India and US? What are some best organisational practices that India can learn from US in gender diversity?"
	                                ),
	                                _react2.default.createElement(
	                                  "div",
	                                  { className: "r_text" },
	                                  "Diversity is a global issue. According to the Q1 Venture Monitor, VCs invested $10B in companies with at least one female founder across 675 deals in Q1 2021 ($22.1B in 2020), and nearly a quarter of all VC deals went to companies with at least one female founder in Q1 2021, consistent with 2020. While the data is trending in the right direction, we still have a long way to go.",
	                                  _react2.default.createElement("br", null),
	                                  "Gender diversity in India is significantly behind when compared to the US \u2013 number of female founders/co-founders, number of female investors (GPs), number of women on boards. $/# of deals invested in women, women-focused funds /accelerators/support groups, etc. Awareness of the issue and prioritizing the problem to implement the right solutions are two critical steps that will help India develop a more diverse innovation economy.",
	                                  _react2.default.createElement("br", null)
	                                ),
	                                _react2.default.createElement(
	                                  "div",
	                                  { className: "r_text_Q" },
	                                  "Q6. Please share your experience and lessons on how start-ups can build culturally diverse teams."
	                                ),
	                                _react2.default.createElement(
	                                  "div",
	                                  { className: "r_text" },
	                                  "Adversity drives innovation. A growing number of companies are adding inclusion and diversity strategy as a part of their growth plans to ensure they are building culturally diverse, strong teams. To help solve the DEI challenge, several start-ups help provide organizations the right tools for accountability and decision-making, including Talenya, Textio, Kanarys, Handshake, The Mom Project, Flockjay, and many more.  ",
	                                  _react2.default.createElement("br", null)
	                                ),
	                                _react2.default.createElement(
	                                  "div",
	                                  { className: "r_text_Q" },
	                                  "Q7. Quick Fire Questions:"
	                                ),
	                                _react2.default.createElement(
	                                  "div",
	                                  { className: "r_text" },
	                                  _react2.default.createElement(
	                                    "ul",
	                                    { style: { marginTop: "-4px" } },
	                                    " ",
	                                    _react2.default.createElement(
	                                      "li",
	                                      null,
	                                      " ",
	                                      _react2.default.createElement(
	                                        "b",
	                                        null,
	                                        _react2.default.createElement(
	                                          "i",
	                                          null,
	                                          "Women need high technical skills to grow as a founder in Silicon Valley "
	                                        )
	                                      ),
	                                      _react2.default.createElement("br", null),
	                                      "Skill sets for a successful founding team (globally) vary from domain knowledge, experience, growth mindset, ability to attract the right talent, etc. Right skills are dependent on what you are building and the problem you are looking to solve. The founding team should have the core skillsets to solve the problem.   ",
	                                      _react2.default.createElement("br", null)
	                                    ),
	                                    _react2.default.createElement(
	                                      "li",
	                                      null,
	                                      _react2.default.createElement(
	                                        "b",
	                                        null,
	                                        _react2.default.createElement(
	                                          "i",
	                                          null,
	                                          " Intersection of identity, for instance being an Indian woman founder overseas (and impact on investing decisions)    "
	                                        )
	                                      ),
	                                      _react2.default.createElement("br", null),
	                                      "My advice for South Asian Female founders looking to fund raise/expand in global markets \u2013 focus on the market, the product and differentiated value. Leverage community support that is available such as Neythri, TiE Women etc. to help build a network that will benefit you personally and professionally. "
	                                    ),
	                                    _react2.default.createElement(
	                                      "li",
	                                      null,
	                                      _react2.default.createElement(
	                                        "b",
	                                        null,
	                                        _react2.default.createElement(
	                                          "i",
	                                          null,
	                                          "   Building global businesses from India  "
	                                        )
	                                      ),
	                                      " ",
	                                      _react2.default.createElement("br", null),
	                                      "Success stories such as Freshworks, Druva, Postman, Browserstack, Darwinbox, Razorpay, Innovacer, Uniphore, and several others have amplified the Indian startup ecosystem\u2019s momentum. I expect global investor confidence will continue to increase and that investment dollars will continue to flow into the region. Founder, market, and investor maturity is visible and adds to the ease / fluidity / success of global businesses from India. We are going to see this exciting trend continue for years to come."
	                                    ),
	                                    _react2.default.createElement(
	                                      "li",
	                                      null,
	                                      _react2.default.createElement(
	                                        "b",
	                                        null,
	                                        _react2.default.createElement(
	                                          "i",
	                                          null,
	                                          "    3 lessons for start-ups in maintaining sustainable growth "
	                                        )
	                                      ),
	                                      " ",
	                                      _react2.default.createElement("br", null),
	                                      _react2.default.createElement(
	                                        "ul",
	                                        null,
	                                        _react2.default.createElement(
	                                          "li",
	                                          null,
	                                          " Cash is King. Strategize when, from who, and how much to raise, balancing debt vs. equity. "
	                                        ),
	                                        _react2.default.createElement(
	                                          "li",
	                                          null,
	                                          " Choose your partners wisely - investors, co-founders, mentors, advisors, etc."
	                                        ),
	                                        _react2.default.createElement(
	                                          "li",
	                                          null,
	                                          "Expanding into a new market? Understand the nuances related to its unique go- to-market approaches and build local teams to drive its growth. "
	                                        )
	                                      )
	                                    ),
	                                    _react2.default.createElement(
	                                      "li",
	                                      null,
	                                      _react2.default.createElement(
	                                        "b",
	                                        null,
	                                        _react2.default.createElement(
	                                          "i",
	                                          null,
	                                          "  3 favourite women entrepreneurs and why "
	                                        )
	                                      ),
	                                      " ",
	                                      _react2.default.createElement("br", null),
	                                      _react2.default.createElement(
	                                        "ul",
	                                        null,
	                                        _react2.default.createElement(
	                                          "li",
	                                          null,
	                                          "Vani Kola \u2013 Founder, Kalaari Capital - One of India\u2019s few female GPs and a great example of what \u201Chustle and believing in their mission could result in.\u201D\xA0 "
	                                        ),
	                                        _react2.default.createElement(
	                                          "li",
	                                          null,
	                                          "Shradha Sharma \u2013 Founder, Yourstory \u2013 Shradha is a top global media influencer today. Watching her go through peaks and valleys while building Yourstory was inspirational. Shradha\u2019s authentic can-do attitude motivates me to never to give up.\xA0\xA0 "
	                                        ),
	                                        _react2.default.createElement(
	                                          "li",
	                                          null,
	                                          "Lakshmi Pratury \u2013 Founder, INK \u2013 Her vision for creating a platform for innovation in India at the intersection of science, technology, community, and culture is forward-thinking, and her passion is highly contagious. Future leaders across diverse spectrums are being created at INK daily. I got a glimpse of those talents in person at the annual retreat at Jaisalmer a few years back."
	                                        )
	                                      )
	                                    ),
	                                    _react2.default.createElement(
	                                      "li",
	                                      null,
	                                      _react2.default.createElement(
	                                        "b",
	                                        null,
	                                        _react2.default.createElement(
	                                          "i",
	                                          null,
	                                          "   Favourite emerging technology "
	                                        )
	                                      ),
	                                      " ",
	                                      _react2.default.createElement("br", null),
	                                      "Not emerging but trending \u2013 AI and ML. There is still a ton of innovation that is expected in the next several years."
	                                    ),
	                                    _react2.default.createElement(
	                                      "li",
	                                      null,
	                                      _react2.default.createElement(
	                                        "b",
	                                        null,
	                                        _react2.default.createElement(
	                                          "i",
	                                          null,
	                                          "   Favourite holiday destination in India  "
	                                        )
	                                      ),
	                                      " ",
	                                      _react2.default.createElement("br", null),
	                                      "Jaisalmer (Thanks INK Retreat!)"
	                                    ),
	                                    _react2.default.createElement(
	                                      "li",
	                                      null,
	                                      _react2.default.createElement(
	                                        "b",
	                                        null,
	                                        _react2.default.createElement(
	                                          "i",
	                                          null,
	                                          "  Favourite sport or work out technique"
	                                        )
	                                      ),
	                                      " ",
	                                      _react2.default.createElement("br", null),
	                                      "Zumba. I would never miss my Monday class at Clubsport."
	                                    )
	                                  )
	                                ),
	                                _react2.default.createElement("div", { className: "r_text_Q" }),
	                                _react2.default.createElement("div", { className: "r_text_Q" })
	                              ),
	                              _react2.default.createElement(
	                                "div",
	                                { className: "footer_sm_icon" },
	                                _react2.default.createElement(
	                                  "div",
	                                  { className: "headsocialLink" },
	                                  _react2.default.createElement(
	                                    "span",
	                                    { className: "hicon" },
	                                    _react2.default.createElement(
	                                      "a",
	                                      {
	                                        href: "https://www.facebook.com/sharer/sharer.php?u=https://winpeforum.com" + location.pathname,
	                                        target: "_blank",
	                                        className: "",
	                                        style: { display: "block !important" }
	                                      },
	                                      _react2.default.createElement("img", {
	                                        src: "https://winpeforum.com/assets/elements/SM_icon_01_new.png",
	                                        alt: ""
	                                      })
	                                    )
	                                  ),
	                                  _react2.default.createElement(
	                                    "span",
	                                    { className: "hicon" },
	                                    _react2.default.createElement(
	                                      "a",
	                                      {
	                                        style: { display: "block !important" },
	                                        href: "https://twitter.com/intent/tweet?url=https://winpeforum.com" + location.pathname,
	                                        target: "_blank",
	                                        className: ""
	                                      },
	                                      _react2.default.createElement("img", {
	                                        src: "https://winpeforum.com/assets/elements/SM_icon_02_new.png",
	                                        alt: ""
	                                      })
	                                    )
	                                  ),
	                                  _react2.default.createElement(
	                                    "span",
	                                    { className: "hicon" },
	                                    _react2.default.createElement(
	                                      "a",
	                                      {
	                                        style: { display: "block !important" },
	                                        href: "https://www.linkedin.com/sharing/share-offsite/?url=https://winpeforum.com" + location.pathname,
	                                        target: "_blank",
	                                        className: ""
	                                      },
	                                      _react2.default.createElement("img", {
	                                        src: "https://winpeforum.com/assets/elements/social_Media_icon_03_new_new.png",
	                                        alt: ""
	                                      })
	                                    )
	                                  ),
	                                  _react2.default.createElement(
	                                    "span",
	                                    { className: "hicon" },
	                                    _react2.default.createElement(
	                                      "button",
	                                      {
	                                        style: {
	                                          display: "block !important",
	                                          width: "25px"
	                                        },
	                                        className: "forwardMail",
	                                        title: "Forward to email",
	                                        onClick: this.toggleMailShareForm
	                                      },
	                                      _react2.default.createElement("img", { src: _sendMailIcon2.default, alt: "" })
	                                    )
	                                  )
	                                )
	                              )
	                            ),
	                            _react2.default.createElement(
	                              "div",
	                              { className: "back_event" },
	                              _react2.default.createElement(
	                                _gatsbyLink2.default,
	                                { to: "/insights" },
	                                _react2.default.createElement(
	                                  "i",
	                                  { className: "fa fa-arrow-left" },
	                                  " ",
	                                  "browse Insights"
	                                )
	                              )
	                            )
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(TeamModal, {
	              show: isShow,
	              onHide: this.togglePopUp,
	              activeItem: this.state.activeItem
	            })
	          )
	        )
	      )
	    );
	  };
	
	  return PriyaRajan;
	}(_react2.default.Component);
	
	PriyaRajan.propTypes = {
	  location: _propTypes2.default.object
	};
	
	exports.default = PriyaRajan;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-insights-priya-rajan-js-3ffb92a514cb0e2ae36e.js